'use client';

import React, { FC } from 'react';
import ReviewReply from '@/components/(postTypes)/platforms/(archive)/layout/(review)/list/ReviewReply';
import { countCommentReplies } from '@/utils/post/comments/countCommentReplies';
import { toPersianDigits } from '@/utils/persianUtils';
import { REVIEW_SHEET_CLASS } from '@/components/(postTypes)/platforms/(archive)/layout/(review)/sheetClass';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@/components/ui/dialog';

interface CommentReply {
    databaseId: number;
    replies?: {
        nodes: CommentReply[];
    };
}

interface Comment {
    databaseId: number;
    content?: string;
    replies: {
        nodes: CommentReply[];
    };
}

interface ReviewAllRepliesProps {
    comment: Comment;
}

const ReviewAllReplies: FC<ReviewAllRepliesProps> = ({ comment }) => {
    const more = countCommentReplies(comment.replies.nodes) - 1;
    return (
        <Dialog>
            <DialogTrigger className='mt-2 ms-4 w-fit rounded-lg px-3 py-1.5 text-xs font-medium text-progress transition-colors hover:bg-progress/10 dark:text-blue-300'>
                مشاهده {toPersianDigits(String(more))} پاسخ دیگر
            </DialogTrigger>
            <DialogContent className={REVIEW_SHEET_CLASS}>
                <DialogHeader className='!text-right'>
                    <DialogTitle>پرسش و پاسخ</DialogTitle>
                </DialogHeader>
                <div className='min-h-[100px] flex-1 overflow-y-auto'>
                    <ReviewReply comment={comment} all={true} />
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ReviewAllReplies;
